import * as types from './types';
import { loading, error, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

export const getCyclesFromFilters = (data) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `CycleMenu/GetCycleMenus/`,
        data
      );
      dispatch(
        success(types.MANAGE_CYCLE_MENU_SET_GRID_DATA, response.data.Data)
      );
    } catch (ex) {
      dispatch(error(types.MANAGE_CYCLE_MENU_FETCH_ERROR, ex));
    }

    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, false));
  };
};

export const saveNewCycleMenu = (data) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `CycleMenu/Write/`,
        data
      );

      dispatch(setSaveSuccessful(true));
      dispatch({
        type: types.MANAGE_CYCLE_MENU_SET_NEW_CYCLE_MENU,
        payload: {
          id: response.data.Data.Data,
          description: data.Description,
          numberOfDays: parseInt(data.NumberOfDays, 10),
          nutritionStandardId: data.NutritionStandardId,
          servings: parseInt(data.Servings, 10),
          fiscalYear: data.FiscalYear,
          analysisDays: data.AnalysisDays,
        },
      });
      dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, false));
      return true;
    } catch (ex) {
      dispatch(error(types.MANAGE_CYCLE_MENU_FETCH_ERROR, ex));
      dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, false));
      return false;
    }
  };
};

export const setSaveSuccessful = (value) => {
  return {
    type: types.MANAGE_CYCLE_MENU_SET_SAVE_SUCCESSFUL,
    payload: value,
  };
};

export const clearErrors = () => {
  return {
    type: types.MANAGE_CYCLE_MENU_CLEAR_ERRORS,
  };
};

export const setEditing = (editing) => {
  return {
    type: types.MANAGE_CYCLE_MENU_SET_EDITING,
    payload: editing,
  };
};

export const setEditCycleValues = (cycleMenu) => {
  return {
    type: types.MANAGE_CYCLE_MENU_SET_EDIT_CYCLE_VALUES,
    payload: cycleMenu,
  };
};

export const setDuplicating = (duplicating) => {
  return {
    type: types.MANAGE_CYCLE_MENU_SET_DUPLICATING,
    payload: duplicating,
  };
};

export const duplicateCycleMenu = (cycleMenuId) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MANAGE_CYCLE_MENU_DUPLICATE_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `CycleMenu/Duplicate`,
        cycleMenuId
      );
      const result = response.data.Data.Data;
      dispatch(setDuplicating(true));
      dispatch(
        setEditCycleValues({
          id: result.Id,
          description: result.Description,
          numberOfDays: result.NumberOfDays,
          nutritionStandardId: result.NutritionStandardId,
          fiscalYear: result.FiscalYear,
          servings: result.Servings,
          analysisDays: result.AnalysisDays,
        })
      );
      dispatch(loading(types.MANAGE_CYCLE_MENU_DUPLICATE_FETCHING, false));
      return true;
    } catch (ex) {
      dispatch(error(types.MANAGE_CYCLE_MENU_FETCH_ERROR, ex));
      dispatch(loading(types.MANAGE_CYCLE_MENU_DUPLICATE_FETCHING, false));
      return false;
    }
  };
};

export const deleteCycleMenu = (cycleMenuId) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, true));

    try {
      await MPWWebApi.postGenericInsertUpdate(`CycleMenu/Delete`, cycleMenuId);
    } catch (ex) {
      dispatch(error(types.MANAGE_CYCLE_MENU_FETCH_ERROR, ex));
    }

    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, false));
  };
};

export const getSharedDistricts = (cycleMenuId) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Menu/GetSharedDistricts/`,
        cycleMenuId
      );
      dispatch(
        success(
          types.MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS,
          response.data.Data
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching the child districts. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS_ERROR,
          defaultError
        )
      );
    }

    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, false));
  };
};

export const shareCycleMenu = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, true));
      await MPWWebApi.postGenericInsertUpdate(
        `CycleMenu/WriteShareCycleMenu`,
        model
      );
      dispatch(setShareSuccessful(true));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while sharing the cycle menu. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.MANAGE_CYCLE_MENU_SHARE_ERROR,
          defaultError
        )
      );
    }

    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, false));
  };
};

export const unshareCycleMenu = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, true));
      await MPWWebApi.postGenericInsertUpdate(
        `CycleMenu/WriteUnShareCycleMenu`,
        model
      );
      dispatch(setUnshareSuccessful(true));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while unsharing the cycle menu. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.MANAGE_CYCLE_MENU_UNSHARE_ERROR,
          defaultError
        )
      );
    }

    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, false));
  };
};

export const getIsParentDistrict = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Menu/GetSharedDistricts/`,
        null
      );
      dispatch(
        success(
          types.MANAGE_CYCLE_MENU_GET_IS_PARENT_DISTRICT,
          response.data.Data.length > 0
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching the child districts. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.MANAGE_CYCLE_MENU_GET_SHARED_DISTRICTS_ERROR,
          defaultError
        )
      );
    }

    dispatch(loading(types.MANAGE_CYCLE_MENU_FETCHING, false));
  };
};

export const setShareSuccessful = (isSuccess) => {
  return {
    type: types.MANAGE_CYCLE_MENU_SET_SHARE_SUCCESS,
    payload: isSuccess,
  };
};

export const setUnshareSuccessful = (isSuccess) => {
  return {
    type: types.MANAGE_CYCLE_MENU_SET_UNSHARE_SUCCESS,
    payload: isSuccess,
  };
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/listcycles/actions.js